import { useInView } from 'react-intersection-observer'

import Link from 'next/link'

import { EventsBar } from '../../components/events-bar/events-bar'
import { MainMenu } from '../main-menu/main-menu'

import LogoSVG from './img/aviadev-logo.svg'

import CSS from './header.module.css'


const otherEvents = [
    {
        id: 0,
        title: 'FHS',
        url: 'https://futurehospitality.com',
        target: true
    },
    {
        id: 1,
        title: 'FHS World',
        url: 'https://futurehospitality.com/world',
        target: true
    },
    {
        id: 2,
        title: 'FHS Saudi Arabia',
        url: 'https://futurehospitality.com/sa',
        target: true
    },
    {
        id: 5,
        title: 'FHS Africa',
        url: 'https://futurehospitality.com/africa',
        target: true
    },
    {
        id: 12,
        title: 'FHS Egypt',
        url: 'https://futurehospitality.com/egypt',
        target: true
    },
    {
        id: 11,
        title: 'FHS Living',
        url: 'https://futurehospitality.com/living',
        target: true
    },
    {
        id: 6,
        title: 'SAHIC',
        url: 'https://www.sahic.com',
        target: true
    }
]

export const Header = ({ mainMenu }) => {


    const [menuTrigger, inView, entry] = useInView({
		threshold: 0.1,
	})

    const [hideEventsBarTrigger, headerInView, header] = useInView({
		threshold: 0,
        initialInView: true
	})

    return (
        <>
            <span ref={menuTrigger}>
                <EventsBar 
                    hidden={ !headerInView ? true : false }
                    thisEvent={'AviaDev'} 
                    events={otherEvents} 
                    theme={{
                        background: 'var(--dark)',
                        text: 'white',
                        accent: 'var(--accent)'
                    }}
                />
            </span>

            <header ref={hideEventsBarTrigger} className={`${CSS.header} ${ !inView && CSS.fixed }`}>
                
                <a href={'/'} aria-label='Aviadev Home'>
                    <LogoSVG className={CSS.brand}/>
                </a>

                <div className='flex'>
                    <div className={CSS.venue}>
                        <p><span className='fw-600 fs-6'>9–11 June 2027</span> <br/>Lusaka International Convention Centre, Zambia</p>
                    </div>

                    <div className={CSS.ctas}>
                        <a href="https://www.eventbooking.uk.com/AVIADEV-2027/" className={`${CSS.ctaButton} fw-600 caps`}>Purchase Pass</a>
                        {/* <a href="https://delegateselect.com/event/bench/aviadevafrica26/login.html" className={`${CSS.ctaButton} fw-600 caps`} target='_blank'>Access Meetings</a> */}
                        <a href="/keep-me-updated" className={`${CSS.ctaButton} fw-600 caps`}>Keep me Updated</a>
                    </div>


                    <MainMenu mainMenu={mainMenu} otherEvents={otherEvents}/>
                </div>

            </header>
        </>
    )
}

export const HeaderShim = ({ mobileOnly, desktopOnly }) => (
    <div className={`${CSS.shim} ${mobileOnly && CSS.mobileOnly} ${desktopOnly && CSS.desktopOnly}`}></div>
)